import type { ReactNode } from 'react';
import { Flex, Text } from '@radix-ui/themes';
import { ErrorText } from './ErrorText';

export function FormField({ label, error, children }: { label: ReactNode; error?: string; children: ReactNode }) {
  return (
    <Text as="label" size="2">
      <Flex direction="column" gap="1">
        <Text weight="medium">{label}</Text>
        {children}
        {error && <ErrorText>{error}</ErrorText>}
      </Flex>
    </Text>
  );
}
